import React, { Component } from 'react'
import T from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { connect } from 'react-redux'
import cn from 'classnames'
import licenseeDigitFormat from 'helpers/licenseeDigitFormat'

class IndicatorBar extends Component {
  indicatorRef = React.createRef()

  indicatorChildRef = React.createRef()

  static propTypes = {
    bar: T.object.isRequired,
    licensee: T.object.isRequired,
    bottomBarValue: T.oneOfType([T.string, T.number]),
    className: T.string,
    position: T.oneOfType([T.string, T.number]),
    textIndent: T.oneOfType([T.string, T.number]),
    topBarValue: T.oneOfType([T.string, T.number]),
  }

  static defaultProps = {
    bottomBarValue: '',
    className: '',
    position: 0,
    textIndent: 0,
    topBarValue: '',
  }

  state = {
    isTooltipRequired: false,
  }

  componentDidMount() {
    const {
      indicatorChildRef: { current: childCurrent },
      indicatorRef: { current },
    } = this

    this.setState({
      isTooltipRequired:
        childCurrent &&
        current &&
        childCurrent.getBoundingClientRect().width >
          current.getBoundingClientRect().width,
    })
  }

  renderIndicatorLevel = text => (
    <span ref={this.indicatorRef} className="ma-indicator-level">
      <span ref={this.indicatorChildRef}>{text}</span>
    </span>
  )

  render() {
    const { isTooltipRequired } = this.state
    const {
      bar: { metric_value, criticality_level },
      className,
      licensee,
      position,
      textIndent,
      topBarValue,
      bottomBarValue,
    } = this.props
    const metricValue = Boolean(metric_value || metric_value === 0)
    const indicatorLevel = this.renderIndicatorLevel(
      licenseeDigitFormat(bottomBarValue, licensee),
    )

    return (
      <div className={`ma-indicator-bar ${className}`}>
        {metricValue && (
          <span
            className="ma-indicator-value"
            style={{
              right: `${position}%`,
              textIndent: `${textIndent}%`,
            }}>
            {licenseeDigitFormat(topBarValue, licensee)}
          </span>
        )}
        {Boolean(criticality_level) && (
          <div
            className={cn('ma-indicator-field', {
              [criticality_level]: criticality_level,
              'ma-indicator-light': metricValue,
            })}>
            {(bottomBarValue === 0 || !!bottomBarValue) &&
              (isTooltipRequired ? (
                <Tooltip
                  title={bottomBarValue}
                  placement="top"
                  classes={{ tooltip: 'custom-tooltip' }}>
                  {indicatorLevel}
                </Tooltip>
              ) : (
                indicatorLevel
              ))}
          </div>
        )}
      </div>
    )
  }
}

export default connect(state => ({
  licensee: state.getIn(['profile', 'profile', 'licensee']),
}))(IndicatorBar)
